import { Button, Dialog, DialogActions, DialogContent, FormControl, Grid } from '@mui/material';
import requests from 'api/requests';
import { useSnackbar } from 'notistack';
import RequestStatus from 'pages/admin/driverRequest/instanceModal/status';
import { IDriverRequestStatus } from 'pages/admin/driverRequest/instanceModal/status/types';
import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { FORM } from './config';
import { FIELDS } from './fields';
import { IDriverRequest } from './types';

interface InstanceModalProps {
  instance: IDriverRequest;
  onClose?: () => void;
  onStatusChange?: () => void;
}

export default function InstanceModal(props: InstanceModalProps) {
  const match: any = useRouteMatch();
  const atp = match.params.id;

  const { enqueueSnackbar } = useSnackbar();
  const [instance, setInstance] = useState({ ...props.instance });
  const [newStatusInstance, setNewStatusInstance] = useState<IDriverRequestStatus | null>(null);

  const {
    onClose,
    onStatusChange
  } = props;

  useEffect(() => {
    setInstance({ ...props.instance })
  }, [props.instance])

  const handleChange = (name: keyof IDriverRequest) => (event: any) => {
    handleChangeValue(name)(event.target.value);
  };

  const handleChangeValue = (name: keyof IDriverRequest) => (value: any) => {
    instance[name] = value as never;
    setInstance({ ...instance });
  }

  const addNewStatus = (statusInstance: IDriverRequestStatus): Promise<any> => {
    return requests.post('/admin/driver/request/status/', {
      ...statusInstance,
      atp_id: atp,
    }).then((r) => {
      enqueueSnackbar("Статус додано", { variant: 'success' });
      return r.body;
    })
  }

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}

    >
      <DialogContent
        dividers={true}
      >

        <Grid container spacing={3}>
          {FORM["COMPANY_CAR"].fields.map((field_name) => {
            const field = FIELDS[field_name].field(instance[field_name], handleChange(field_name), instance.id);
            if (!field) return null
            return (
              <Grid key={field_name} item xs={12} md={6}>
                <FormControl fullWidth key={field_name}>
                  {field}
                </FormControl>
              </Grid>
            )
          })}
        </Grid>

        <RequestStatus
          requestID={instance.id}
          onStatusChange={() => {
            if (onStatusChange) {
              onStatusChange()
            }
          }}

          newStatusInstance={newStatusInstance}
          onChangeNewStatusInstance={setNewStatusInstance}
          addNewStatus={addNewStatus}
        />

      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
        >
          Закрити
        </Button>
      </DialogActions>
    </Dialog>
  );
}